import React, { FunctionComponent, memo, useState } from 'react';
import { Text, TextInput, ComponentGroup } from 'bohr-web';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
// import _isEmpty from 'lodash/isEmpty';

import Close from '../../../UI/CloseButton';
import { Container, CloseButtonContainer, DateContainer } from './index.styled';
import DatePick from '../../../UI/Date';
import { modifyTransactionDate } from '../../helper';
import Search from '../../../Icons/svg/search.svg';
import { sendEvent2 } from '../../../../utils/tracking';

interface Props {
  dispatchToStoreGetVehicle: Function;
  updateParams: Function;
  dispatchToStoreReset: Function;
  vehicleNumber: string;
}

const Overview: FunctionComponent<Props> = memo(
  ({ dispatchToStoreGetVehicle, updateParams, dispatchToStoreReset, vehicleNumber }) => {
    const history: any = useHistory();

    const [dates, setDates] = useState({});
    const [error, setError] = useState('');
    const [vehicleError, setVehicleError] = useState('');
    const [, setPage] = useState(0);

    const vehicleData = useSelector((state: any) => _get(state, 'fasTagDetail.vehicleData', {}));

    const [vNum, setVNum] = useState(vehicleNumber);

    const validateDate = (label: string, value: Date) => {
      const dateObj = modifyTransactionDate(label, value, dates, true);
      setDates(dateObj);
      const { startDate, endDate } = dateObj;
      if (!vehicleData.vehicleId) {
        setVehicleError('Enter Vehicle Number');
      } else {
        setError('');
      }
      if (startDate && endDate) {
        const diff = endDate - startDate;
        if (diff < 0) {
          setError('Start Date cannot be greater that End Date');
        } else {
          setError('');
          setPage(0);
          updateParams({
            pageNo: 0,
            fromTime: startDate,
            toTime: endDate,
            reset: true,
          });
        }
      }
    };

    const handleEnter = (e: any) => {
      e.stopPropagation();
      sendEvent2(
        'search_btn',
        {
          event_action: 'click',
          event_category: 'top_nav',
          screen_name: 'ft_vehicle_txn_details',
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
      if (e.charCode === 13) {
        setVehicleError('');
        if (e.target.value) {
          dispatchToStoreGetVehicle({ searchText: e.target.value, details: true, reset: true });
        } else {
          dispatchToStoreReset();
        }
      }
    };

    const handleChange = (e: any) => {
      setVNum(e.target.value);
    };

    return (
      <Container>
        <Text
          text={vehicleNumber || 'All Fastag Report'}
          size="header2"
          variant="bold"
          referenceClass="vehicle-number"
        />
        <DateContainer className="flex relative date-field">
          <div className="mr16 relative">
            <DatePick
              name="startDate"
              timePicker={true}
              placeholder="Start Date"
              value={null}
              changeHandler={(val: Date) => {
                sendEvent2(
                  'start_date_btn',
                  {
                    event_action: 'click',
                    event_category: 'top_nav',
                    screen_name: 'ft_vehicle_txn_details',
                    target_product: 'fastag',
                    event_platform: 'web',
                  },
                  true,
                );
                validateDate('startDate', val);
              }}
            />
          </div>
          <div className="relative">
            <DatePick
              timePicker={true}
              name="endDate"
              placeholder="End Date"
              value={null}
              changeHandler={(val: Date) => {
                sendEvent2(
                  'end_date_btn',
                  {
                    event_action: 'click',
                    event_category: 'top_nav',
                    screen_name: 'ft_vehicle_txn_details',
                    target_product: 'fastag',
                    event_platform: 'web',
                  },
                  true,
                );
                validateDate('endDate', val);
              }}
            />
          </div>
          <Text text={error} color="error" referenceClass={error ? 'smaller b0 error absolute ' : 'hide'} />
        </DateContainer>
        <ComponentGroup
          variant="block"
          referenceClass="vehicle-search-container"
          components={[
            {
              component: TextInput,
              propsData: {
                placeholder: 'VehicleNo.',
                value: vNum,
                startIcon: Search,
                onKeyPress: handleEnter,
                onChange: handleChange,
                className: 'search-vehicle',
              },
            },
            {
              component: Text,
              propsData: {
                text: vehicleError,
                color: 'error',
                referenceClass: vehicleError ? 'b0 error absolute' : 'hide',
              },
            },
          ]}
        />
        <CloseButtonContainer>
          <Close
            handler={() => {
              sendEvent2(
                'close_btn',
                {
                  event_action: 'click',
                  event_category: 'top_nav',
                  screen_name: 'ft_vehicle_txn_details',
                  target_product: 'fastag',
                  event_platform: 'web',
                },
                true,
              );
              history.replace('/portal/fastag');
            }}
          />
        </CloseButtonContainer>
      </Container>
      // <div className="p30 pl90 pt24 bg-white mt2 pr30">
      //   <div className="flex justify-content-s">
      //     <div className="flex justify-content-c">
      //       <span className="mr5 font-light-grey ">Fastag Balance :</span>
      //       <span className="fwb">{parsePrice({ price: fastagAmount })}</span>
      //       <span className="ml25">
      //         <Recharge tagId={tagId} amount={fastagAmount} vehicle={vehicleNumber} />
      //       </span>
      //       <div className="ml16">
      //         {!_isEmpty(vehicleData) ? (
      //           <AutoRecharge
      //             autoRecharge={autoRecharge}
      //             minBalance={minBalance}
      //             onText="Auto Recharge ON"
      //             offText="Auto Recharge OFF"
      //             tagId={tagId}
      //             layout="row"
      //             vehicleNumber={vehicleNumber}
      //           />
      //         ) : null}
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
  },
);

export default Overview;
